import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import SvgGeneral from '@material-ui/icons/VerifiedUser';

const styles = (theme) => {
    return {
        section: {
            width: '95%',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginBottom: 24,
            overflow: 'hidden',
        },
        sectionTitleBlock: {
            display: 'inline-block',
            width: '100%',
            height: 64,
            textAlign: 'left',
            backgroundColor: 'rgba(206, 142, 64, 0.17)',
        },
        sectionTitleText: {
            display: 'inline-block',
            color: theme.palette.text.secondary,
            verticalAlign: 'middle',
            fontSize: 26,
            fontVariant: 'small-caps',
        },
        sectionTitleIcon: {
            ...theme.iconStyle.size[36],
            ...theme.iconStyle.dark,
            display: 'inline-block',
            marginLeft: 12,
            marginRight: 16,
            marginTop: 14,
            marginBottom: 14,
            verticalAlign: 'middle',
        },
        sectionContentBlock: {
            height: 56,
            paddingLeft: 16,
            paddingRight: 16,
        },
        sectionContentLabel: {
            float: 'left',
            height: 24,
            marginTop: 16,
            marginBottom: 16,
            color: theme.palette.text.secondary,
            verticalAlign: 'middle',
            fontVariant: 'small-caps',
            cursor: 'default',
        },
        sectionContentText: {
            float: 'right',
            marginTop: 16,
            marginBottom: 16,
            color: theme.palette.text.secondary,
            verticalAlign: 'middle',
            '&$clickable': {
                color: theme.palette.secondary.main,
                cursor: 'pointer',
                textTransform: 'uppercase',
            },
        },
        clickable: {},
    };
}

class GeneralProfile extends Component {
    render = () => {
        const {classes} = this.props;

        return (
            <Paper
                className={classes.section}
                elevation={1}
            >
                <div className={classes.sectionTitleBlock}>
                    <SvgGeneral className={classes.sectionTitleIcon}/>
                    <Typography
                        className={classes.sectionTitleText}
                        align='left'
                        variant='h6'
                    >
                        General
                    </Typography>
                </div>
                <div className={classes.sectionContentBlock}>
                    <Typography
                        className={classes.sectionContentLabel}
                        align='left'
                        variant='subtitle1'
                    >
                        Name
                    </Typography>
                    <Typography
                        className={classes.sectionContentText}
                        align='right'
                    >
                        {this.props.info.first_name} {this.props.info.last_name}
                    </Typography>
                </div>
                <Divider/>
                <div className={classes.sectionContentBlock}>
                    <Typography
                        className={classes.sectionContentLabel}
                        align='left'
                        variant='subtitle1'
                    >
                        Email
                    </Typography>
                    <Typography
                        className={classes.sectionContentText}
                        align='right'
                    >
                        {this.props.info.user_name}
                    </Typography>
                </div>
                <Divider/>
                <div className={classes.sectionContentBlock}>
                    <Typography
                        className={classes.sectionContentLabel}
                        align='left'
                        variant='subtitle1'
                    >
                        Password
                    </Typography>
                    <Typography
                        className={classNames(classes.sectionContentText, classes.clickable)}
                        align='right'
                        onClick={this._handleResetPassword}
                    >
                        Reset
                    </Typography>
                </div>
            </Paper>
        );
    }

    _handleResetPassword = (event) => {
        event.preventDefault();

        if (this.props.onResetPassword) {
            this.props.onResetPassword();
        }
    }
}

GeneralProfile.propTypes = {
    info: PropTypes.object,
    onResetPassword: PropTypes.func,
}

export default withStyles(styles)(GeneralProfile);
